import React from 'react';
import { render } from 'react-dom';
import { Router, browserHistory } from 'react-router';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { Provider } from 'react-redux';
import 'flexboxgrid/css/flexboxgrid.css';
import 'reset-css/reset.css';
import { setLanguages, addTranslation, setActiveLanguage } from 'react-localize-redux';
import moment from 'moment';

import routes from './routes';
import store from './redux/store';
import NotificationCenter from './containers/NotificationCenter';
import './favicon.ico';
import './assets/css/global.css';
// import stringTranslation from './translations/strings';
// import enumTranslation from './translations/enums';
// import errorTranslation from './translations/errors';
injectTapEventPlugin();

// @TODO move language code
const languages = ['en', 'de', 'fr', 'it'];
const activeLanguage = window.localStorage.getItem('lang') || 'de';

store.dispatch(setLanguages(languages));
store.dispatch(setActiveLanguage(activeLanguage));
// store.dispatch(addTranslation(stringTranslation));
// store.dispatch(addTranslation(enumTranslation));
// store.dispatch(addTranslation(errorTranslation));

moment.locale(activeLanguage);

render(
  <Provider store={store}>
    <div>
      <Router routes={routes} history={browserHistory} />
      <NotificationCenter />
    </div>
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js